export default {
      id: "tech-usage",
      viewBox: "0 0 502 512.01",
      url: __webpack_public_path__ + "img/svg-sprite.svg#tech",
      toString: function () {
        return this.url;
      }
    }